import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import categoriesApi from './../../api/Categories.api';
import utils from './../../utils/utilities';
import xhr from './../../utils/xhr';

import LoadingSpinner from './../LoadingSpinner/LoadingSpinner.index.jsx';
import ThirdPartiesCategories from './ThirdPartyRadioGroupOptions/ThirdParties.categories';
import SpecificThirdParties from './ThirdPartyRadioGroupOptions/ThirdParties.specificEntities';

class ThirdParties extends React.Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        values: PropTypes.object
    }

    static defaultProps = {
        values: {
            categoryNames: {},
            selectedCategories: [],
            allCategoriesSelected: false,
            selectedThirdParties: [],
            thirdPartySelection: 'all-third-parties-section',
            loadingSpinner: 0,
            totalCount: null,
            filterCount: null,
            urlParams: {
                sortBy: 'companyTitle',
                direction: 'asc',
                categoryIdFilter: null,
                refreshToggle: 0
            }
        }
    }

    constructor(props) {
        super(props);

        // just initialize the state with the props, keep the component variables contained
        this.state = props.values

        this.thirdPartiesRadioNavigation = this.thirdPartiesRadioNavigation.bind(this);
    }

    componentDidMount() {
        // initialize the parent with the default values
        this.props.onChange(this.state);
    }

    setTempState(state) {
        this.state = { ...this.state, ...state }
        this.forceUpdate();
    }

    actions = {
        toggleSelectAllCategories: (selectAll) => {
            if (selectAll) {
                this.setTempState({
                    selectedCategories:    [...Object.keys(this.state.categoryNames)],
                    allCategoriesSelected: true
                })
            } else {
                this.setTempState({
                    selectedCategories:    [],
                    allCategoriesSelected: false
                })
            }
            this.props.onChange(this.state);
        },
        requestCategoryLabels: () => {
            this.actions.showSpinner();
            return categoriesApi
                .getCategoryNames()
                .then((categories) => {
                    this.actions.setCategories(categories);
                    this.actions.hideSpinner();
                    return categories;
                }).catch((error) => {
                    console.log(error);
                    this.actions.hideSpinner();
                    //xhr.handleAllErrors(error);
                });
        },
        addSelectedItems: (selectedItems) => {
            let newArray = utils.mergeArraysByField('id', this.state.selectedThirdParties, selectedItems);
            this.setTempState({ selectedThirdParties: newArray })
        },
        showSpinner: () => {
            this.setTempState({ loadingSpinner: this.state.loadingSpinner > 0 ? this.state.loadingSpinner : 1 })
        },
        hideSpinner: () => {
            this.setTempState({ loadingSpinner: this.state.loadingSpinner > 0 ? this.state.loadingSpinner - 1 : 0 })
        },
        setCategories: (categoryNames) => {
            this.setTempState({ categoryNames })
        },
        toggleCategory: (categoryId, itemIndex) => {
            if (itemIndex === -1) {
                let categories = [...this.state.selectedCategories, categoryId];
                this.setTempState({
                    selectedCategories:    categories,
                    allCategoriesSelected: categories.length === Object.keys(this.state.categoryNames).length
                })
            } else {
                this.setTempState({
                    selectedCategories:    [
                        ...this.state.selectedCategories.slice(0, itemIndex),
                        ...this.state.selectedCategories.slice(itemIndex + 1)
                    ],
                    allCategoriesSelected: false
                })
            }
            this.props.resetEntitiesSectionValidation();
            this.props.onChange(this.state);
        },
        selectThirdPartiesOption: (selection) => {
            this.setTempState({
                selectedCategories:     [],
                selectedThirdParties:   [],
                allCategoriesSelected:  false,
                thirdPartySelection: selection
            })
            this.props.onChange(this.state);
        },
        changeTableUrlParams: (params) => {
            this.setTempState({
                urlParams: Object.assign({}, this.state.urlParams, params)
            })
        },
        countThirdParties: (count) => {
            this.setTempState({ totalCount: count })
        },
        filterCountThirdParties: (count) => {
            this.setTempState({ filterCount: count })
        },
        countEntries: () => {
            let url='/api/entities/companies/active/count';

            this.actions.countThirdParties(null);
            this.actions.filterCountThirdParties(null)
            let params = this.state.urlParams;

            xhr.get({
                url:     url
            }).then((response) => {
                this.actions.countThirdParties(response.body)

                if (!params.categoryIdFilter && !params.searchFilter) {
                    this.actions.filterCountThirdParties(response.body)
                }
            }).catch((error) => {
                utils.logError(error, 'BaseFeedEditing.actions.countEntries(): ');

                if (error.status === 400) {
                    this.actions.countThirdParties(0)
                    this.actions.filterCountThirdParties(0)
                } else {
                    xhr.handleAllErrors(error);
                }
            });

            if (params.categoryIdFilter || params.searchFilter) {
                let queryParams = {};

                if (params.categoryIdFilter) {
                    queryParams['categoryIdFilter'] = params.categoryIdFilter;
                }

                if (params.searchFilter) {
                    queryParams['searchFilter'] = params.searchFilter;
                }

                xhr.get({
                    url: url,
                    data: queryParams
                }).then((response) => {
                    this.actions.filterCountThirdParties(response.body)
                }).catch((error) => {
                    utils.logError(error, 'BaseFeedEditing.actions.countEntries(): ');

                    if (error.status === 400) {
                        this.actions.filterCountThirdParties(0);
                    } else {
                        xhr.handleAllErrors(error);
                    }
                });
            }
        },
        selectThirdParties: (itemIds) => {
            let newArray = utils.mergeArraysByField('id', this.state.selectedThirdParties, itemIds);
            this.setTempState({ selectedThirdParties: newArray });
            this.props.onChange(this.state);
            this.props.resetEntitiesSectionValidation();
        },
        deselectThirdParty: (itemIndex) => {
            if (itemIndex !== -1) {
                this.setTempState({
                        selectedThirdParties: [
                            ...this.state.selectedThirdParties.slice(0, itemIndex),
                            ...this.state.selectedThirdParties.slice(itemIndex + 1)
                        ]
                    }
                );
            }
            this.props.onChange(this.state);
        },
        clearThirdPartyIds: () => {
            this.setTempState({
                selectedThirdPartiesIds: []
            })
        },
        clearThirdParties: () => {
            this.setTempState({ selectedThirdParties: [] })
            this.props.onChange(this.state);
        },
        refreshTable: () => {
            let refreshToggle = this.state.urlParams.refreshToggle;

            this.setTempState({ urlParams: Object.assign({}, this.state.urlParams, { refreshToggle: refreshToggle === 0 ? 1 : 0 }) })
        },
        selectAll: () => {
            let state = this.state;
            let queryParams = {
                pageNumber: -1,
                pageSize: -1,
                sortBy: state.urlParams.sortBy,
                direction: state.urlParams.direction
            };

            if (state.urlParams.categoryIdFilter) {
                queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
            }

            if (state.urlParams.searchFilter) {
                queryParams['searchFilter'] = state.urlParams.searchFilter;
            }

            return xhr.get({
                url: '/api/entities/active',
                data: queryParams
            }).then((response)=> {
                this.actions.addSelectedItems(response.body);

                this.props.onChange(this.state);
            }).catch((err) => {
                console.log("********************** Failed to select all ********************");
                console.log(err);
                xhr.handleAllErrors(err);
            });
        },
        unSelectAll: () => {
            let state = this.state;
            let queryParams = {
                pageNumber: -1,
                pageSize: -1,
                sortBy: state.urlParams.sortBy,
                direction: state.urlParams.direction
            };

            if (state.urlParams.categoryIdFilter) {
                queryParams['categoryIdFilter'] = state.urlParams.categoryIdFilter;
            }

            if (state.urlParams.searchFilter) {
                queryParams['searchFilter'] = state.urlParams.searchFilter;
            }

            return xhr.get({
                url: '/api/entities/active',
                data: queryParams
            }).then((response)=> {
                this.actions.removeSelectedItems(response.body);
                this.props.onChange(this.state);
            }).catch((err) => {
                console.log("********************** Failed to select all ********************");
                console.log(err);
                xhr.handleAllErrors(err);
            });
        },
        getSelectedEntities: (data, callback) => {
            let url = '/api/entities/specific-companies';
            return xhr.post({
                url:  url,
                data: data
            }).then((response) => {
                if (callback) {
                    callback(response.body);
                }
            }).catch((err) => {
                console.log("********************** Failed to sync selection store ********************");
                console.log(err);
                xhr.handleAllErrors(err);
            });
        },
        removeSelectedItems: (selectedItems) => {
            let newArray = utils.subsetArrayByField('id', this.state.selectedThirdParties, selectedItems);

            this.setTempState({ selectedThirdParties: newArray });

            this.props.onChange(this.state);
        }
    }

    thirdPartiesRadioNavigation(event) {

        let selectedSectionName = event.target.value;
        if (this.state.thirdPartySelection === selectedSectionName) {
            return;
        }

        this.props.resetEntitiesSectionValidation();

        this.actions.selectThirdPartiesOption(selectedSectionName);

        this.props.onChange(this.state);
    }

    options = {
        "all-third-parties-section": {
            label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll"/>,
            component: <AllEntities />
        },
        "categories-section": {
            label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectByCategory" />,
            component: <ThirdPartiesCategories resetSection={this.actions.selectThirdPartiesOption}/>
        },
        "specific-third-parties-section": {
            label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectBySpecific"/>,
            component: <SpecificThirdParties />
        }
    }

    render() {

        let currentSelection = this.state.thirdPartySelection;

        const option = React.cloneElement(this.options[this.state.thirdPartySelection].component, {
            setErrorClass: this.props.setErrorClass,
            actions: this.actions,
            state: this.state
        })

        return (
            <div className="rss-section__third-parties">

                <div className="title third-parties-title">
                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.title" />
                </div>

                <div className='third-parties-disclaimer'><FormattedMessage id='Alerts_Create_UIText_name.step1.entities.info'/></div>

                <div className="selectors">

                    <span className="selectors__wrapper selectors__all-third-parties">
                        <input checked={currentSelection === 'all-third-parties-section'}
                               id="add-rss-feed__third-parties--radio-button-1"
                               type="radio"
                               name="third-parties"
                               value="all-third-parties-section"
                               onChange={this.thirdPartiesRadioNavigation} />
                        <label htmlFor="add-rss-feed__third-parties--radio-button-1">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll" />
                        </label>
                    </span>

                    <span className="selectors__wrapper selectors__category">
                        <input checked={currentSelection === 'categories-section'}
                               id="add-rss-feed__third-parties--radio-button-2"
                               type="radio"
                               name="third-parties"
                               value="categories-section"
                               onChange={this.thirdPartiesRadioNavigation} />
                        <label htmlFor="add-rss-feed__third-parties--radio-button-2">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectByCategory" />
                        </label>
                    </span>

                    <span className="selectors__wrapper selectors__specific-third-parties">
                        <input checked={currentSelection === 'specific-third-parties-section'}
                               id="add-rss-feed__third-parties--radio-button-3"
                               type="radio"
                               name="third-parties"
                               value="specific-third-parties-section"
                               onChange={this.thirdPartiesRadioNavigation} />
                        <label htmlFor="add-rss-feed__third-parties--radio-button-3">
                            <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectBySpecific" />
                        </label>
                    </span>

                </div>

                <div className="rss-section__third-parties__section-content">

                    {
                        this.props.errorMessage ?
                            <div className="error-message"><FormattedMessage id={this.props.errorMessage}/></div>
                            :
                            null
                    }

                    <LoadingSpinner isInner isVisible={this.state.loadingSpinner > 0 ? true : false} />
                    {option}
                </div>

            </div>

        );

    }
}

const AllEntities = ({}) => <div className="third-parties-sections all-third-parties-section">
    <b><FormattedMessage id="Alerts_Create_UIText_name.step1.entities.all"/></b>
</div>

export default ThirdParties;


// WEBPACK FOOTER //
// ./src/scripts/reusable/Form/ThirdPartyRadioGroup.jsx